/**
 * 设置分享数据
 */
export const setShareData = function() {
  const title = '友邻学院，招生开启'
  const desc = '期待你的加入'
  const imgUrl = 'https://img-cdn1.ylyk.com/image/1607669766979_m1607669725295_s88348.jpg' // 友邻学院
  if (title) {
    const link = location.href
    // 设置页面分享链接
    // const indexName = 'goods-studyplan'
    // const index = link.indexOf(indexName)
    // link = link.substr(0, index + indexName.length)
    return { title, desc, link, imgUrl }
  }
}

// 空页面回跳
export const replaceTo_GoodsStudyPlan = function(id) {
  if (id == null) {
    this.$router.replace({ path: `/goods-studyplan` })
  }
}